export default {
  validacaoSolicitacao: state => state.validacaoSolicitacao
};
